import { Skeleton } from "@atlant/ui"

import { formatAmount, sortTotals } from "#utils/money.ts"

import type { MonthSummary } from "../../components/month-card.tsx"

interface MonthKpisProps {
  summary?: MonthSummary
  isLoading: boolean
}

export const MonthKpis = ({ summary, isLoading }: MonthKpisProps) => {
  const [primary, ...other] = sortTotals(summary?.totals ?? [])

  const kpis: { label: string; value: string; accent?: boolean; sub?: string[] }[] = [
    {
      label: "Invoices in month",
      value: String(summary?.invoiceCount ?? 0),
      accent: true,
    },
    {
      label: "Total amount",
      value: primary
        ? formatAmount(primary.amount, primary.currency)
        : formatAmount("0", "EUR"),
      accent: true,
      sub: other.map(({ amount, currency }) => `+ ${formatAmount(amount, currency)}`),
    },
    { label: "Auto-match rate", value: "—" },
    { label: "Late", value: String(summary?.lateCount ?? 0) },
    { label: "Disputed", value: String(summary?.needsReviewCount ?? 0) },
  ]

  return (
    <div className="bg-card flex rounded-lg border">
      {kpis.map(({ label, value, accent, sub }, i) => (
        <div key={label} className="flex min-w-0 flex-1 items-stretch">
          <div className="flex flex-1 flex-col gap-0.5 p-3">
            <span className="text-muted-foreground text-xs font-medium">{label}</span>
            {isLoading ? (
              <Skeleton className="h-6 w-20" />
            ) : (
              <span
                className={
                  accent
                    ? "text-primary text-lg font-semibold"
                    : "text-foreground text-lg font-semibold"
                }
              >
                {value}
              </span>
            )}
            {sub?.map((line) => (
              <span key={line} className="text-muted-foreground text-xs">
                {line}
              </span>
            ))}
          </div>
          {i < kpis.length - 1 && (
            <div className="flex items-center py-2">
              <div className="bg-border h-full w-px" />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
